import { FC } from "react";

import { Box } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";

import { FullWidthVStack } from "@components/common";
import EmailInput from "@components/EmailInput";
import Icon from "@components/Icon";
import { useMessage } from "@components/Message";
import PhoneInput from "@components/PhoneInput";
import TextInput from "@components/TextInput";
import { useRouter } from "@lib/router";
import { LockerInput } from "@modules/locker-search";
import { DOMAIN } from "@utils/constants";

import { OrderFields, ORDER_MESSAGE_ZONE } from "../../../constants";

type TLockerFormProps = {
  country: string;
};

const LockerForm: FC<TLockerFormProps> = ({ country }) => {
  const { t } = useTranslation();

  const { defaultLocale } = useRouter();

  const setMessage = useMessage();

  const handleLockerSearchError = (error?: string) => {
    setMessage({
      message: error || t("order-message-failed_locker_search"),
      props: {
        variant: "error",
        icon: <Icon icon="warning" size="1.45rem" />,
        canClose: true,
        padding: "0.45rem 0.75rem",
      },
      zone: ORDER_MESSAGE_ZONE,
    });
  };

  return (
    <FullWidthVStack spacing="1.25rem">
      <Box data-field={OrderFields.NEW_ADDRESS_NAME}>
        <TextInput
          name={OrderFields.NEW_ADDRESS_NAME}
          label={t("order-receiver-name")}
          id="order-new_locker-address-name"
        />
      </Box>
      <Box data-field={OrderFields.NEW_ADDRESS_PHONE}>
        <PhoneInput
          name={OrderFields.NEW_ADDRESS_PHONE}
          label={t("order-receiver-mobile_number")}
          id="order-new_locker-address-phone"
          pinnedPhoneCodes={DOMAIN.DOMAIN_PHONE_NUMBERS[defaultLocale!]}
        />
      </Box>
      <Box data-field={OrderFields.NEW_ADDRESS_EMAIL}>
        <EmailInput
          name={OrderFields.NEW_ADDRESS_EMAIL}
          label={`${t("order-receiver-email")} ${t("common-optional")}`}
          id="order-new_locker-address-email"
        />
      </Box>
      <LockerInput
        countryCode={country}
        lockerCodeFieldName={OrderFields.NEW_ADDRESS_LOCKER}
        lockerNameFieldName={OrderFields.NEW_ADDRESS_LOCKER_NAME}
        lockerPostalCodeFieldName={OrderFields.NEW_ADDRESS_ZIP_CODE}
        label={t("order-receiver-choose_locker")}
        onError={handleLockerSearchError}
        id="order-new_locker-address-locker"
      />
    </FullWidthVStack>
  );
};
export default LockerForm;
